import React, {useState, Component} from 'react';
import * as firebase from 'firebase'
import NotificationAlert from 'react-notification-alert';
import { Redirect, Route } from 'react-router'

let mobileExistNotification


export default class CheckStatus2 extends Component {
  // const [weightText, setWeightText] = useState("")
constructor(props){
   super(props);
   this.state={
    loading: false,
    mobileNumber: '',
    redirect: false
   }
} 

onCheckClick(){
  var d = new Date();
   var n = d.getSeconds();
 
   if(n>50){

  this.setState({loading: true})
         const dbRefObject = firebase.database().ref().child('users');
           dbRefObject.once('value', snapshot => {
             // convert messages list from snapshot
             const usersObject = snapshot.val();
       
             if (usersObject) {
               const usersList = Object.keys(usersObject).map(key => ({
                 ...usersObject[key],
                 uid: key,
               }));
              // var user = firebase.auth().currentUser;
       
       this.setState({ loading: false})
       let mobileExist  = false
       for(let i=0; i<usersList.length; i++){
      
        if(usersList[i].mobileNumber===this.state.mobileNumber || usersList[i].applicationID ===this.state.mobileNumber ){
          mobileExist = true
          // console.log('true')
          // console.log(usersList)
//mobileExist = true
           //this.setState({name: this.state.sellersData[i].name, gender: this.state.sellersData[i].gender, address:this.state.sellersData[i].address})
        }
        
          } 
      //  console.log(mobileExist)

      if(mobileExist===true){
         localStorage.setItem('mobileNumberDetails', this.state.mobileNumber)
this.setState({redirect: true})
      }

     else if(mobileExist===false){
        this.setState({redirect: false})
        mobileExistNotification =
    {
      place: 'tl',
      message: (
        <div>
          <div>
            Mobile number not registered or Invalid Application ID
          </div>
        </div>
      ),
      type: "danger",
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 5
    }

    this.refs.notify.notificationAlert(mobileExistNotification);


      }
             
             } else {
             // console.log('nothing')

                this.setState({loading: false})

              //  this.setState({name: '', gender: 'male', address: '', loader: false})

               // this.setState({ users: null, });
             }
           });
        }
           else{
           window.location ="https://readplaywin.com"
          //  window.location ="https://subscribe4u.com"

           }
    }
    onChange = event => {
      this.setState({ [event.target.name]: event.target.value });
  
    };

componentDidMount(){
  
}
render(){
  return (
      <>
       <NotificationAlert ref="notify" />

  <div class="container" style={{maxWidth: 700, marginBottom: 150}}>
    <h5 style={{color: 'gray'}}>Check your Application Status below:</h5>
<div class="input-group mb-3" style={{marginTop: 30}}>
  <input type="text" class="form-control" placeholder="Mobile Number or Application ID"
  name="mobileNumber" value={this.state.mobileNumber}
  onChange={this.onChange} maxLength="16"/>
  <div class="input-group-append">
    <button class="btn btn-success" disabled={this.state.mobileNumber.length<11} onClick={() => this.onCheckClick()} type="submit">
    <span hidden={this.state.loading===true}>CHECK</span>
                         <div hidden={this.state.loading===false} style={{marginBottom:'-5px', marginTop: '-5px'}} class="spinner-border text-light"></div>
          
    </button>
  </div>
  {/* <p style={{textAlign:'justify', color: 'green', fontSize: 12, marginTop: 10}}>All Applicants who haven't been able to view the status of their application yet should be patient. <b>Read Play Win</b> is owned by one of our Philanthropists. It's a good educative earning game and we endorse it to all Nigerian Youths. </p>  */}

</div>



</div>

{this.state.redirect === true && (
          <Redirect to={'/status'} />
        )}
</>
  );
}}

